module.exports = __webpack_public_path__ + "img/avatar5.67ac4e99.png";